<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Theme </v-card-title>
          <v-card-text>
            <v-switch
              :model-value="themeSwitch"
              :label="'Theme is ' + themeText"
              @change="toggleTheme"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Storage </v-card-title>
          <v-card-actions>
            <v-btn color="red" @click="clearFormStoreLocalStorage">
              Clear Form Store Local Storage
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Use Debug Mode </v-card-title>
          <v-card-text>
            <v-switch
              v-model="debugMode"
              :label="'Debug mode is ' + (debugMode ? 'ON' : 'OFF')"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Use Sitemaps </v-card-title>
          <v-card-text>
            <v-switch
              v-model="sitemapMode"
              :label="'Sitemap usage is ' + (sitemapMode ? 'Disabled' : 'Enabled')"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useSettings from '@/composables/useSettings/useSettings';

const {
  theme: { toggleTheme, isThemeDark, getThemeText },
  clearFormStoreLocalStorage,
  debugMode,
  sitemapMode,
} = useSettings();

const themeSwitch = computed(() => isThemeDark());
const themeText = computed(() => getThemeText());
</script>
